import { useCallback } from "react";
import EntitySearchBox from "../../common/crud/EntitySearchBox";
import useClients from "../../hooks/store/clients";
import usePermissions from "../../hooks/usePermissions";

export const ClientSearch = () => {
  const {
    getClientsDataAction,
    setRowsPerPageAction,
    setPageNumberAction,
    searchClientDataAction,
    rowsPerPage,
    page,
    getClientDataByClientAction,
    clientSearchByClient,
  } = useClients();
  const { clientId, isClient } = usePermissions();

  const handleResetPagination = useCallback(
    (paginationState) => {
      setRowsPerPageAction(paginationState.rowsPerPage);
      setPageNumberAction(paginationState.page);
    },
    [setPageNumberAction, setRowsPerPageAction]
  );

  const loadPage = useCallback(
    ({ limit, offSet, signal }) => {
      if (isClient && clientId) {
        getClientDataByClientAction({
          clientIdLogin: clientId,
          limit,
          offSet,
          signal,
        });
        return;
      }

      getClientsDataAction({
        limit,
        offSet,
        signal,
      });
    },
    [clientId, getClientDataByClientAction, getClientsDataAction, isClient]
  );

  const searchPage = useCallback(
    ({ limit, name, offSet, signal }) => {
      if (isClient && clientId) {
        clientSearchByClient({
          name,
          signal,
          clientIdLogin: clientId,
          limit,
          offSet,
        });
        return;
      }

      searchClientDataAction({
        name,
        signal,
        limit,
        offSet,
      });
    },
    [clientId, clientSearchByClient, isClient, searchClientDataAction]
  );

  return (
    <EntitySearchBox
      hidden={isClient && Boolean(clientId)}
      loadPage={loadPage}
      onResetPagination={handleResetPagination}
      page={page}
      placeholder="Search Client"
      rowsPerPage={rowsPerPage}
      searchPage={searchPage}
    />
  );
};
